import { getCookie } from '../../utils/cookies';
import CONFIG from 'config';

/* eslint-disable camelcase */
export default class Gtag {
    // Prod G-RQW4D1KZF0
    // dev G-7R0B1GWH47
    load() {
        // Crea il dataLayer se non esiste
        window.dataLayer = window.dataLayer || [];
        // Definisce la funzione gtag per inviare dati a Google Analytics
        function gtag() {
            window.dataLayer.push(arguments);
        }

        const AcceptedPurposesArray = getCookie('__cmpAcceptedPurposes')?.split('|');

        if (document.location.href.indexOf('video-embed') === -1) {
            if (document.readyState === 'complete' || document.readyState === 'interactive') {
                if (window.RcsDataLayer.__cpmtClicked === 'accept') {
                    gtag('consent', 'default', {
                        ad_storage: AcceptedPurposesArray.includes('7') ? 'granted' : 'denied',
                        ad_user_data:
                            AcceptedPurposesArray.includes('2') && AcceptedPurposesArray.includes('3') && AcceptedPurposesArray.includes('4')
                                ? 'granted'
                                : 'denied',
                        ad_personalization:
                            AcceptedPurposesArray.includes('2') && AcceptedPurposesArray.includes('3') && AcceptedPurposesArray.includes('4')
                                ? 'granted'
                                : 'denied',
                        analytics_storage: AcceptedPurposesArray.includes('8') && AcceptedPurposesArray.includes('9') ? 'granted' : 'denied',
                        personalization_storage:
                            AcceptedPurposesArray.includes('5') && AcceptedPurposesArray.includes('6') && AcceptedPurposesArray.includes('11')
                                ? 'granted'
                                : 'denied',
                        functionality_storage: AcceptedPurposesArray.includes('1') && AcceptedPurposesArray.includes('10') ? 'granted' : 'denied',
                    });
                    // Inizializza Google Analytics con la data corrente
                    gtag('js', new Date());

                    // Configura Google Analytics con il tuo ID GA4 e i dati da passare

                    gtag('config', CONFIG.build.gtagVer, {
                        sub_section: window.RcsDataLayer.page_section_lv1,
                        page_section: window.RcsDataLayer.page_section_lv1,
                        sub_section_2: window.RcsDataLayer.page_section_lv2,
                        sub_section_3: window.RcsDataLayer.page_section_lv3,
                        site_name: window.RcsDataLayer.site_name,
                        page_url: window.RcsDataLayer.page_url_full,
                        login_status: window.RcsDataLayer.user_login_status,
                        content_page_type: window.RcsDataLayer.content_page_type,
                        article_name: window.RcsDataLayer.article_name,
                        permutive_id: window.RcsDataLayer.permutive_user_id,
                        profilazione_cmp: window.RcsDataLayer.__cpmtClicked,
                        adunit: window.RcsDataLayer.page_adv,
                        content_type: window.RcsDataLayer.tipologia,
                        user_type: window.RcsDataLayer.user_registration_type,
                        device_adv: window.RcsDataLayer.device_adv,
                        user_id: window.RcsDataLayer.user_id_runa,
                        banner_privacy: window.RcsDataLayer.cpmt_trk,
                        page_type: window.RcsDataLayer.page_refresh_type,
                    });

                    googletag.cmd.push(() => {
                        // Aggiunge un listener per intercettare quando uno slot viene renderizzato
                        googletag.pubads().addEventListener('slotRenderEnded', (event) => {
                            const slot = event.slot;

                            // Ottiene le informazioni della creatività servita (se disponibili)
                            const info = slot.getResponseInformation?.();

                            if (!info) {
                                console.warn('Nessuna informazione disponibile per lo slot:', slot.getSlotElementId());

                                return;
                            }
                            gtag('event', 'impression', {
                                ad_unit_path: slot.getAdUnitPath(), // Percorso dell'Ad Unit (es. /1234567/sito/homepage)
                                div_id: slot.getSlotElementId(), // ID del contenitore HTML del banner
                                line_item_id: info.lineItemId, // ID della linea (line item)
                                campaign_id: info.campaignId, // ID della campagna
                                creative_id: info.creativeId, // ID della creatività
                                is_backfill: info.isBackfill, // True se è remnant (non venduto)
                                page_url: window.location.href, // URL completo della pagina
                                timestamp: new Date().toISOString(),
                            });
                        });
                    });
                }
            } else {
                window.addEventListener('DOMContentLoaded', () => {
                    if (window.RcsDataLayer.__cpmtClicked === 'accept') {
                        gtag('consent', 'default', {
                            ad_storage: AcceptedPurposesArray.includes('7') ? 'granted' : 'denied',
                            ad_user_data:
                                AcceptedPurposesArray.includes('2') && AcceptedPurposesArray.includes('3') && AcceptedPurposesArray.includes('4')
                                    ? 'granted'
                                    : 'denied',
                            ad_personalization:
                                AcceptedPurposesArray.includes('2') && AcceptedPurposesArray.includes('3') && AcceptedPurposesArray.includes('4')
                                    ? 'granted'
                                    : 'denied',
                            analytics_storage: AcceptedPurposesArray.includes('8') && AcceptedPurposesArray.includes('9') ? 'granted' : 'denied',
                            personalization_storage:
                                AcceptedPurposesArray.includes('5') && AcceptedPurposesArray.includes('6') && AcceptedPurposesArray.includes('11')
                                    ? 'granted'
                                    : 'denied',
                            functionality_storage: AcceptedPurposesArray.includes('1') && AcceptedPurposesArray.includes('10') ? 'granted' : 'denied',
                        });
                        // Inizializza Google Analytics con la data corrente
                        gtag('js', new Date());

                        // Configura Google Analytics con il tuo ID GA4 e i dati da passare
                        gtag('config', CONFIG.build.gtagVer, {
                            sub_section: window.RcsDataLayer.page_section_lv1,
                            page_section: window.RcsDataLayer.page_section_lv1,
                            sub_section_2: window.RcsDataLayer.page_section_lv2,
                            sub_section_3: window.RcsDataLayer.page_section_lv3,
                            site_name: window.RcsDataLayer.site_name,
                            page_url: window.RcsDataLayer.page_url_full,
                            login_status: window.RcsDataLayer.user_login_status,
                            content_page_type: window.RcsDataLayer.content_page_type,
                            article_name: window.RcsDataLayer.article_name,
                            permutive_id: window.RcsDataLayer.permutive_user_id,
                            profilazione_cmp: window.RcsDataLayer.__cpmtClicked,
                            adunit: window.RcsDataLayer.page_adv,
                            content_type: window.RcsDataLayer.tipologia,
                            user_type: window.RcsDataLayer.user_registration_type,
                            device_adv: window.RcsDataLayer.device_adv,
                            user_id: window.RcsDataLayer.user_id_runa,
                            banner_privacy: window.RcsDataLayer.cpmt_trk,
                            page_type: window.RcsDataLayer.page_refresh_type,
                        });

                        googletag.cmd.push(() => {
                            // Aggiunge un listener per intercettare quando uno slot viene renderizzato
                            googletag.pubads().addEventListener('slotRenderEnded', (event) => {
                                const slot = event.slot;

                                // Ottiene le informazioni della creatività servita (se disponibili)
                                const info = slot.getResponseInformation?.();

                                if (!info) {
                                    console.warn('Nessuna informazione disponibile per lo slot:', slot.getSlotElementId());

                                    return;
                                }
                                gtag('event', 'impression', {
                                    ad_unit_path: slot.getAdUnitPath(), // Percorso dell'Ad Unit (es. /1234567/sito/homepage)
                                    div_id: slot.getSlotElementId(), // ID del contenitore HTML del banner
                                    line_item_id: info.lineItemId, // ID della linea (line item)
                                    campaign_id: info.campaignId, // ID della campagna
                                    creative_id: info.creativeId, // ID della creatività
                                    is_backfill: info.isBackfill, // True se è remnant (non venduto)
                                    page_url: window.location.href, // URL completo della pagina
                                    timestamp: new Date().toISOString(),
                                });
                            });
                        });
                    }
                });
            }
        }
    }
}
